 import { useEffect, useState } from "react";
import Navbar from "../components/Navbar";

function AdminDashboard() {
  const [activeTab, setActiveTab] = useState("court"); // 'court' or 'payouts'
  const [cases, setCases] = useState([]);
  const [withdrawals, setWithdrawals] = useState([]);
  const [loading, setLoading] = useState(false);
  const [zoomedImage, setZoomedImage] = useState(null);

  useEffect(() => {
    if (activeTab === "court") fetchCases();
    else fetchWithdrawals();
  }, [activeTab]);

  // ⚖️ FETCH COURT CASES
  const fetchCases = async () => {
    try {
      const token = localStorage.getItem("token");
      const res = await fetch("https://borrowhub-backend.onrender.com/api/admin/disputes", {
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = await res.json();
      if (data.success) setCases(data.cases);
    } catch (err) { console.error(err); }
  };


   const handleRetry = async (itemId) => {
    // 🛑 1. Check karo ki kya humare paas Item ke andar borrow record ki ID hai
    // Hum backend se Item bhej rahe hain, usme borrow record dhoondhna hoga
    setLoading(true);
    try {
      const token = localStorage.getItem("token"); // ✅ Token yahan define kiya
      
      const res = await fetch("https://borrowhub-backend.onrender.com/api/admin/retry-charge", {
        method: "POST",
        headers: { 
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}` 
        },
        // 🔥 Backend ko itemId bhej rahe hain (Backend mein hum findOne borrow by itemId kar lenge)
        body: JSON.stringify({ itemId }) 
      });
      
      const data = await res.json();
      alert(data.message);
      if (data.success) fetchCases(); 
    } catch (err) {
      alert("Retry failed! Check Console.");
    } finally {
      setLoading(false);
    }
  };

  // 💸 FETCH WITHDRAWAL REQUESTS
  const fetchWithdrawals = async () => {
    try {
      const token = localStorage.getItem("token");
      const res = await fetch("https://borrowhub-backend.onrender.com/api/admin/withdrawals", {
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = await res.json();
      if (data.success) setWithdrawals(data.withdrawals);
    } catch (err) { console.error(err); }
  };

  // ⚖️ HANDLE THEFT/DISPUTE VERDICT
  const handleVerdict = async (itemId, decision) => {
    const actionText = decision === "GUILTY" ? "EXECUTE PENALTY & ADD TO WALLET" : "DISMISS CASE";
    const adminNote = prompt(`Admin Note for ${actionText}:`, "Resolved issue.");
    if (!adminNote) return; 

    setLoading(true);
    try {
      const token = localStorage.getItem("token");
      const res = await fetch("https://borrowhub-backend.onrender.com/api/admin/resolve", {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
        body: JSON.stringify({ itemId, decision, adminNote }),
      });
      const data = await res.json();
      alert(data.message);
      fetchCases(); 
    } catch { alert("Server Error"); } 
    finally { setLoading(false); }
  };

  // 💸 HANDLE PAYOUT (Mark as Paid)
  const handleApprovePayout = async (withdrawalId) => {
    if (!window.confirm("Aapne ye paise apne PhonePe/GPay se bhej diye hain?")) return;
    setLoading(true);
    try {
      const token = localStorage.getItem("token");
      const res = await fetch(`https://borrowhub-backend.onrender.com/api/admin/withdrawals/${withdrawalId}/approve`, {
        method: "PUT",
        headers: { Authorization: `Bearer ${token}` }
      });
      const data = await res.json();
      alert(data.message);
      fetchWithdrawals();
    } catch { alert("Server Error"); }
    finally { setLoading(false); }
  };

  const formatDate = (date) => new Date(date).toLocaleDateString("en-IN");

  return (
    <>
      <Navbar />

      {/* 🔍 ZOOM MODAL */}
      {zoomedImage && (
        <div className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center" style={{ backgroundColor: "rgba(0,0,0,0.9)", zIndex: 9999 }} onClick={() => setZoomedImage(null)}>
          <img src={zoomedImage} alt="Zoomed" style={{ maxHeight: "90vh", maxWidth: "90vw", border: "2px solid white" }} />
          <button className="btn btn-close btn-close-white position-absolute top-0 end-0 m-4"></button>
        </div>
      )}

      <div className="container mt-5">
        <h2 className="text-dark fw-bold mb-4">👑 Admin Control Panel</h2>

        {/* TABS */}
        <ul className="nav nav-pills nav-justified mb-4 shadow-sm rounded">
          <li className="nav-item">
            <button className={`nav-link fw-bold ${activeTab === "court" ? "active bg-danger" : "text-dark"}`} onClick={() => setActiveTab("court")}>
              ⚖️ Court Cases (Theft)
            </button>
          </li>
          <li className="nav-item">
            <button className={`nav-link fw-bold ${activeTab === "payouts" ? "active bg-success" : "text-dark"}`} onClick={() => setActiveTab("payouts")}>
              💸 Payout Requests
            </button>
          </li>
        </ul>

        {/* =======================================
             TAB 1: COURT CASES
        ======================================= */}
        {activeTab === "court" && (
          <div>
            {cases.length === 0 ? (
              <div className="alert alert-success text-center py-5"><h4>No active cases! 🎉</h4></div>
            ) : (
              <div className="row">
                {cases.map((c) => (
                  <div key={c._id} className="col-12 mb-4">
                    <div className="card shadow border-danger">
                      <div className="card-header bg-danger text-white d-flex justify-content-between">
                        <span className="fw-bold">🆔 Item: {c.title}</span>
                        <span className="badge bg-light text-danger">ACTION REQUIRED</span>
                      </div>
                      <div className="card-body row">
                        {/* Borrower Info */}
                        <div className="col-md-4 border-end">
                          <h6 className="text-danger fw-bold">🛑 The Accused (Borrower)</h6>
                          <p className="mb-0"><b>{c.borrowedBy?.name}</b></p>
                          <p className="small">{c.borrowedBy?.phone}</p>
                          <hr />
                          <small><strong>Mandate Value:</strong> ₹{c.deposit || 10000}</small>
                        </div>
                        {/* Owner Info */}
                        <div className="col-md-4 border-end">
                          <h6 className="text-success fw-bold">🛡️ The Victim (Owner)</h6>
                          <p className="mb-1"><b>{c.owner?.name}</b></p>
                          <p className="small">{c.owner?.phone}</p>
                          <div className="alert alert-light border mt-2 p-2 small">
                            <strong>📢 Reason:</strong> {c.adminCourt?.reason || "Theft/Damage"}
                          </div>
                        </div>
                        {/* Actions */}
                        <div className="col-md-4 text-center d-flex flex-column justify-content-center">
                          <button className="btn btn-success w-100 mb-2" disabled={loading} onClick={() => handleVerdict(c._id, "INNOCENT")}>
                            🕊️ Dismiss Case <br/><small>(False alarm)</small>
                          </button>
                          <button className="btn btn-dark w-100 border-danger border-2" disabled={loading} onClick={() => handleVerdict(c._id, "GUILTY")}>
                            🔨 EXECUTE PENALTY <br/><small className="text-danger fw-bold">(Deduct & Add to Wallet)</small>
                          </button>
                          {/* 🔥 SMART RETRY BUTTON: Sirf tab dikhao jab pehla charge fail hua ho */}
    {/* 🔥 SMART RETRY BUTTON */}
{/* Condition: FAILED ya MANUAL likha ho, LEKIN "Success" NA likha ho */}
{(c.adminCourt?.adminNote?.includes("FAILED") || c.adminCourt?.adminNote?.includes("MANUAL")) && !c.adminCourt?.adminNote?.includes("✅ Success") && (
  <button 
    className="btn btn-warning w-100 fw-bold shadow-sm mt-2" 
    disabled={loading} 
    onClick={() => handleRetry(c._id)}
  >
    {loading ? "⌛ Retrying..." : "🔄 Retry Charge (Paisa Vasool)"}
  </button>
)}

{/* 🔥 SUCCESS MESSAGE (Button ki jagah ye dikhega) */}
{c.adminCourt?.adminNote?.includes("✅ Success") && (
  <div className="alert alert-success mt-2 p-2 text-center" style={{ fontSize: "11px", marginBottom: "0" }}>
    <strong>✅ Payment Recovered & Mandate Cancelled!</strong>
  </div>
)}
                        </div>
                        
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        )}

        {/* =======================================
             TAB 2: PAYOUT REQUESTS
        ======================================= */}
        {activeTab === "payouts" && (
          <div>
            {withdrawals.length === 0 ? (
              <div className="alert alert-success text-center py-5"><h4>No pending payouts! 💸</h4></div>
            ) : (
              <div className="table-responsive shadow-sm rounded bg-white">
                <table className="table table-hover align-middle mb-0">
                  <thead className="table-dark">
                    <tr>
                      <th>Lender Name</th>
                      <th>Amount</th>
                      <th>UPI ID (Pay Here)</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {withdrawals.map((w) => (
                      <tr key={w._id}>
                        <td className="fw-bold">{w.user?.name}</td>
                        <td className="text-success fw-bold fs-5">₹{w.amount}</td>
                        <td>
                          <div className="bg-light border rounded px-3 py-2 d-inline-block font-monospace">
                            {w.upiId}
                          </div>
                        </td>
                        <td>
                          <button className="btn btn-success fw-bold" onClick={() => handleApprovePayout(w._id)} disabled={loading}>
                            ✅ Mark as Paid
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        )}

      </div>
    </>
  );
}

export default AdminDashboard;